import React, { useState, useEffect } from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import "../../styles/CustomStepper.css";
import { getStoredFormData } from "../../utils/formStorage";
import { DMQStepNames, MAIN_STEPS } from "../../constants/constants";
import { Row } from "antd";

export const isStepCompleted = (stepId, stored) => {
  switch (stepId) {
    case MAIN_STEPS.PERSONAL_DETAILS:
      return stored[DMQStepNames.PERSONAL_DETAILS] && stored[DMQStepNames.ADDRESS_DETAILS] ? true : false;

    case MAIN_STEPS.MEDICAL_HISTORY:
      return stored[DMQStepNames.GENERAL_HISTORY] && stored[DMQStepNames.MEDICAL_HISTORY] && stored[DMQStepNames.INSURANCE_HISTORY] ? true : false;

    case MAIN_STEPS.NRI_QUESTIONNAIRE:
      return stored[DMQStepNames.NRI_QUESTIONNAIRE] ? true : false;

    case MAIN_STEPS.FOREIGN_NATIONAL_QUESTIONNAIRE:
      return stored[DMQStepNames.FOREIGN_NATIONAL_QUESTIONNAIRE] ? true : false;

    case MAIN_STEPS.DIABETIC_QUESTIONNAIRE:
      return stored[DMQStepNames.DIABETIC_QUESTIONNAIRE] ? true : false;

    case MAIN_STEPS.BLOOD_PRESSURE_QUESTIONNAIRE:
      return stored[DMQStepNames.BLOOD_PRESSURE_QUESTIONNAIRE] ? true : false;

    case MAIN_STEPS.THYROID_QUESTIONNAIRE:
      return stored[DMQStepNames.THYROID_QUESTIONNAIRE] ? true : false;

    case MAIN_STEPS.KIDNEY_QUESTIONNAIRE:
      return stored[DMQStepNames.KIDNEY_QUESTIONNAIRE] ? true : false;

    default:
      return false;
  }
};

const CustomStepper = ({ steps, currentStep, onStepChange }) => {
  const stored = getStoredFormData();

  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 0);
  const breakPoint = 620;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="custom-stepper-wrapper">
      <Row justify={windowWidth > breakPoint ? "center" : "start"}>
        <div className="custom-stepper">
          {steps.map((step, index) => {
            const isCompleted = isStepCompleted(step.id, stored);
            const isActive = step.id === currentStep;

            return (
              <div key={step.id} className="step-item">
                <div className={`step-circle ${isCompleted ? "completed" : isActive ? "active" : ""}`} onClick={() => onStepChange(step.id)}>
                  {isCompleted ? <CheckCircleFilled /> : <span>{index + 1}</span>}
                </div>

                <div
                  className={`step-label ${isCompleted ? "completed-label" : isActive ? "active-label" : ""}`}
                  onClick={() => onStepChange(step.id)}
                >
                  {step.title}
                </div>

                {index < steps.length - 1 && <div className="step-connector" />}
              </div>
            );
          })}
        </div>
      </Row>
    </div>
  );
};

export default CustomStepper;
